import { createRouter, createWebHistory } from 'vue-router'
import rani from './rani'
import amd from './amd'
import shrm from './shrm'
import irq from './irq'
import bnpl from './bnpl'
import jti from './jti'
import capo from './capo'
import boomerang from './boomerang'
import voucher from './voucher'
import uwin from './uwin'
import gorji from './gorji'

let speceficRoutes = []
switch (CONFIG.DIR) {
  case 'rani':
    speceficRoutes = rani
    break
  case 'boomerang':
    speceficRoutes = boomerang
    break
  case 'amd':
    speceficRoutes = amd
    break
  case 'jti':
    speceficRoutes = jti
    break
  case 'uwin':
    speceficRoutes = uwin
    break
  case 'shrm':
    speceficRoutes = shrm
    break
  case 'voucher':
    speceficRoutes = voucher
    break
  case 'capo':
    speceficRoutes = capo
    break
  case 'irq':
    speceficRoutes = irq
    break
  case 'bnpl':
    speceficRoutes = bnpl
    break
  case 'gorji':
    speceficRoutes = gorji
    break
  default:
    speceficRoutes = rani
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      meta: {
        title: 'user.userSettings',
      },
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/public/ProfileView.vue'),
    },
    {
      meta: {
        title: 'menu.reports',
      },
      path: '/report/:name',
      name: 'producer_reports',
      component: () => import('@/views/public/ReportView.vue'),
    },
    {
      meta: {
        title: 'menu.form',
      },
      path: '/form/:name',
      name: 'form',
      component: () => import('@/views/public/FormView.vue'),
    },
    {
      meta: {
        title: 'menu.editForm',
      },
      path: '/form/:name/:param',
      name: 'form-edit',
      component: () => import('@/views/public/FormView.vue'),
    },
    {
      meta: {
        title: 'menu.adminForm',
      },
      path: '/admin/form/:name',
      name: 'admin-form',
      component: () => import('@/views/public/FormView.vue'),
    },
    {
      meta: {
        title: 'menu.adminEditForm',
      },
      path: '/admin/form/:name/:param',
      name: 'admin-form-edit',
      component: () => import('@/views/public/FormView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/public/LoginView.vue'),
    },
    {
      meta: {
        title: 'menu.notFound',
      },
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/404Page.vue'),
    },
    ...speceficRoutes,
  ],
  linkActiveClass: 'nav-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  },
})

export default router
